import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { ContactForm } from '../Models/ContactForm';

class ContactFormApi {
  static getContactForm(id: string) {
    return axios.get<ContactForm>(
      `${API_URL}/api/customer/GetContactForm/${id}`,
      getAuthHeader()
    );
  }
  static addContactForm(request: ContactForm) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/customer/AddUpdateContact`,
      request
    );
  }
  static getContactFormList() {
    return axios.get<ContactForm[]>(
      `${API_URL}/api/customer/GetContactForms`,
      getAuthHeader()
    );
  }
}

export default ContactFormApi;
